export const api_link = 'https://api-gain.web-treeosk.online';
export const key = 'Password123+';